import connectionProxy from './connectionProxy'

export const getMeasures = () => connectionProxy.http.get('unidades_de_medida')



// WEBPACK FOOTER //
// ./src/api/measures.js